<template>
  <modal
    :title="setModel.Id + ' - ' + setModel.Name + ' Detail'"
    :size="'xl'"
    @close="$emit('close')"
  >
    <template #content>
      <ul
        class="nav nav-tabs profile-tab"
        style="overflow-x:auto; overflow-y:hidden; margin-bottom:0;"
      >
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'Detail'"
            :class="{ active: tab == 'Detail' }"
            class="nav-link"
            >Detail</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'Hotels'"
            :class="{ active: tab == 'Hotels' }"
            class="nav-link"
            >Hotels</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'Users'"
            :class="{ active: tab == 'Users' }"
            class="nav-link"
            >Users</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'Providers'"
            :class="{ active: tab == 'Providers' }"
            class="nav-link"
            >Providers</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'Contacts'"
            :class="{ active: tab == 'Contacts' }"
            class="nav-link"
            >Contacts</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'dedicatedProxies'"
            :class="{ active: tab == 'dedicatedProxies' }"
            class="nav-link"
            >Proxies</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'SalesInvoices'"
            :class="{ active: tab == 'SalesInvoices' }"
            class="nav-link"
            >Sales Invoices</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'ApproveReasons'"
            :class="{ active: tab == 'ApproveReasons' }"
            class="nav-link"
            >Approve Reasons</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'Notes'"
            :class="{ active: tab == 'Notes' }"
            class="nav-link"
            >Notes</a
          >
        </li>
      </ul>
      <upsert
        :setModel="setModel"
        @update="$emit('update', $event)"
        v-if="tab == 'Detail'"
      ></upsert>
      <hotels :setModel="setModel" v-if="tab == 'Hotels'"></hotels>
      <users :setModel="setModel" v-if="tab == 'Users'"></users>
      <providers :setModel="setModel" v-if="tab == 'Providers'"></providers>
      <contacts :setModel="setModel" v-if="tab == 'Contacts'"></contacts>
      <salesInvoices
        :setModel="setModel"
        v-if="tab == 'SalesInvoices'"
      ></salesInvoices>
      <approveReasons :setModel="setModel" v-if="tab=='ApproveReasons'"></approveReasons>
      <notes :setModel="setModel" v-if="tab == 'Notes'"></notes>
      <dedicatedProxies  :setModel="setModel" v-if="tab == 'dedicatedProxies'"></dedicatedProxies>
    </template>
  </modal>
</template>

<script>
import upsert from "../upsert";
import hotels from "./hotels/main";
import users from "./users/main";
import providers from "./providers/main";
import contacts from "./contacts/main";
import salesInvoices from "./salesInvoices/main.vue";
import approveReasons from "./approveReasons.vue";
import notes from "./notes/main";
import dedicatedProxies from "./dedicatedProxies/main.vue";
export default {
  name: "detail",
  components: { upsert, hotels, users, contacts, providers, salesInvoices,approveReasons, notes,dedicatedProxies },
  props: {
    setModel: Object,
  },
  data() {
    return {
      tab: "Detail",
    };
  },
};
</script>

<style scoped>
.nav-tabs .nav-item {
  vertical-align: middle;
  overflow: hidden;
}
</style>
